module.exports = ".ph-row {\n  flex-wrap: wrap;\n  margin-bottom: 0;\n}\n"